export default {
  not_localised: 'Questo documento non è ancora disponibile nella tua regione. Mostriamo la versione inglese.',
};
